import { C } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { fromEvent, Observable, of, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { QualService } from 'src/app/qual/service/qual.service';
import { ProjectDashboardService } from 'src/app/shared/services/project.dashboard.service';
import { RecruiterServices } from 'src/app/shared/services/recruiter.services';
import {ReportService, Item, ReportDetails, translation_config } from '../service/report.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { RepoApiService } from '../service/repo-api.service';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Component({
  selector: 'app-create-report',
  templateUrl: './create-report.component.html',
  styleUrls: ['./create-report.component.scss']
})
export class CreateReportComponent implements OnInit, AfterViewInit, OnDestroy {
  public createReportForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    description : new FormControl('', [Validators.required]),
    objective : new FormControl(''),
    type : new FormControl('', [Validators.required]),
    tags : new FormControl(''),
    source : new FormControl(''),
    completion_date : new FormControl(''),
    projectId : new FormControl(''),
    projectName : new FormControl(''),
    file : new FormControl(''),
    dataTable : new FormControl(false),
    file_type : new FormControl(''),
    job_id : new FormControl('')

    // separators : new FormControl('')
  });
  public fileObj:FileList;
  public projects:any = [{id:'2118b97b-e2f1-4961-af1a-3968208aa2dc',name:'project'}];
  public projectsFiltered:Observable<any[]>;
  public isUpdate:boolean = false;
  public isMove:boolean = false;
  public uuid:string= '';
  public files:any = [];
  public reportList:any = [];
  public uploadFileVariable:boolean = false;
  public acceptableExtentions:string = "";
  public projectCreateName: string = "";
  // public uploadedFiles:any = [];
  public item:Item;
  public reportType:string [] = []; 
  private fileUploadPogressEvent: Subscription;
  private fileUploadPogressEventV2: Subscription;
  private emitFileUploadRepoResponseEvent: Subscription;
  private emitFileUpdateUploadRepoResponseEvent: Subscription;
  public fileUploadPogress:any = 0;
  // public percent = 0;
  public isTranslationFileUpload: boolean = false;
  public isIpsosCrownitOrg: boolean = false;
  public validBuCodeCont:string[] = ['cb9f120a-284a-11e9-83cd-42010a8e0002','d69b3be6-3133-11e9-8d02-42010aa0000a'];
  // public accessRules:any = {};
  public accessRoles = JSON.parse(localStorage.getItem('access')) || {};
  @ViewChild("reportProgressBar") progressBar: ElementRef;

  constructor(public reportService:ReportService,
    private projectService:ProjectDashboardService,
    private notifier:NotifierService,
    public repoService:RepoApiService,
    private apiRequest: ApiRequestService,
    private router:Router,
    private activaterRoute:ActivatedRoute, 
    private recruiterServices:RecruiterServices,
    private QService:QualService,
    private sidePanelService:SidePanelService,
    private render:Renderer2
    ) { 
      this.fileUploadPogressEvent = this.reportService.emitFileUploadPogress.subscribe((uploadState)=>{
        this.fileUploadPogress = uploadState.progress;
        if (this.progressBar) {
          this.reportService.uploadFileProgrespercent = this.fileUploadPogress > this.reportService.uploadFileProgrespercent ? this.fileUploadPogress : this.reportService.uploadFileProgrespercent;
          this.render.setStyle(this.progressBar.nativeElement, 'width', this.reportService.uploadFileProgrespercent+"%");
          // this.progressBar.nativeElement.style.width = this.percent+"%";
        }
      });
      this.fileUploadPogressEventV2 = this.reportService.emitFileUploadPogressV2.subscribe((uploadState)=>{
        this.fileUploadPogress = uploadState.progress == 100 ? 0 : uploadState.progress;
        if (this.progressBar) {
          this.reportService.uploadFileProgrespercent = this.fileUploadPogress > this.reportService.uploadFileProgrespercent ? this.fileUploadPogress : this.reportService.uploadFileProgrespercent;
          this.render.setStyle(this.progressBar.nativeElement, 'width', this.reportService.uploadFileProgrespercent+"%");
        }
      });
      this.emitFileUploadRepoResponseEvent = this.reportService.emitFileUploadRepoResponse.subscribe((response)=>{
        this.uploadReportV2(response.result);
      });

      this.emitFileUpdateUploadRepoResponseEvent = this.reportService.emitFileUpdateUploadRepoResponse.subscribe((response)=>{
        this.updateUploadReportV2(response.result);
      });

     

      
    }
  ngOnDestroy(): void {
    if (this.fileUploadPogressEvent) {
      this.fileUploadPogressEvent.unsubscribe();
    }
    if (this.fileUploadPogressEventV2) {
      this.fileUploadPogressEventV2.unsubscribe();
    }
    // this.percent = 0;
    this.fileUploadPogress = 0;
    this.reportService.showPogress = false;
    if(this.emitFileUploadRepoResponseEvent){
      this.emitFileUploadRepoResponseEvent.unsubscribe();
    }
    if(this.emitFileUpdateUploadRepoResponseEvent){
      this.emitFileUpdateUploadRepoResponseEvent.unsubscribe();
    }
    this.reportService.close()
    this.isIpsosCrownitOrg = false;
  }

  ngOnInit() {
    if(this.accessRoles && this.accessRoles.org_id && this.validBuCodeCont.includes(this.accessRoles.org_id)){
      this.isIpsosCrownitOrg = true;
      this.createReportForm.addControl('bu_code', new FormControl('', [Validators.required]));
    }else{
      this.isIpsosCrownitOrg = false;
      this.createReportForm.removeControl('bu_code');
    }
    this.reportService.translateFileUploadedEvent.subscribe((result)=> {
      this.handleTranslationUpload(result);
    })
    // const typeahead = fromEvent<KeyboardEvent>(document.querySelector('#project-search-box') as HTMLInputElement , 'input').pipe(
    //   map((e: KeyboardEvent) => {return  (<HTMLInputElement>e.target).value}),
    //   filter(text => text.length > 0),
    //   debounceTime(500),
    //   distinctUntilChanged(),
    // );

    // typeahead.subscribe(keyword => {
    //       this.recruiterServices.getGlobalSearch(keyword).subscribe(data => {
    //         if (data.result)
    //           this.projectsFiltered = of(data.result);
              
    //       });
    // });
    
    this.activaterRoute.params.subscribe(param => {
    //   if(this.router.url.includes('repository-report/details')){
    //     this.isUpdate = true;
    //     this.uuid = param['uuid'];
    //     setTimeout(()=>{
    //       this.getRepoDetails(param['uuid']);
    //     })
    // }
    if(this.router.url.includes('repo/details')){
      this.isUpdate = true;
      this.isMove = false;
      this.uuid = param['uuid'];
      setTimeout(()=>{
        this.getRepoDetails(param['uuid']);
      })
    }else if(this.router.url.includes('repo/all-files')){
        this.isUpdate = false;
        this.isMove = true;
      }
    })

  this.reportList = ['Report','Questionnaire','Data Table - ABS','Data Table - PCT','Topline Report','Image','Video','Audio'];

    // this.activaterRoute.params.subscribe(param => {
    //   if(this.router.url.includes('qual/report')){
    //     this.isUpdate = true;
    //     this.uuid = param['uuid'];
    //     setTimeout(()=>{
    //       this.reportService.reportDetails = new ReportDetails();
    //       this.QService.getInterviewDetails();
    //     })
    // }
    // })
    this.reportService.uploadedFiles = [];
  
   
  }

  ngAfterViewInit(): void {
    this.setSearchTypehead();
    // this.progressBar.nativeElement.style.width = this.fileUploadPogress+"%";
  }
  
  setSearchTypehead(){
    const typeahead = fromEvent<KeyboardEvent>(document.querySelector('#project-search-box') as HTMLInputElement , 'input').pipe(
      map((e: KeyboardEvent) => {return  (<HTMLInputElement>e.target).value}),
      filter(text => text.length > 0),
      debounceTime(500),
      distinctUntilChanged(),
    );
  
    typeahead.subscribe(keyword => {
          this.recruiterServices.getGlobalSearch(keyword).subscribe(data => {
            if (data.result)
              this.projectsFiltered = of(data.result);
              
          });
    });
  }

  formatDate(){
    if(this.createReportForm.value.completion_date && typeof this.createReportForm.value.completion_date == 'object'){
      var today = this.createReportForm.value.completion_date;
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      this.createReportForm.patchValue({
        completion_date: today
      });
    }
  }
  
  reload(){
    if(this.uuid != ''){
      this.reportService.isUpload = false
      this.getRepoDetails(this.uuid);
      // this.router.navigate(['home/repository-report/details/',this.uuid])
    }
  }

  getRepoDetails(id){
    // this.formatDate();
    this.reportService.getRepositoryDetails(id).subscribe(result => {
      if(result[0]['status'] == 1){
        result[0]['result']['type'] = result[0]['result']['type'] == 'qual'? 'Qual': result[0]['result']['type'] == 'quant'? 'Quant' : result[0]['result']['type'];
        this.reportService.reportDetails = result[0].result;
        this.createReportForm.patchValue({
          title: result[0]['result']['title'],
          description : result[0]['result']['description'],
          type : result[0]['result']['type'],
          bu_code : result[0]['result']['bu_code'] || '',
          tags : result[0]['result']['tags'],
          source : result[0]['result']['source'],
          projectName:result[0]['result']['project_name'],
          projectId:result[0]['result']['project_id'],
          job_id : result[0]['result']['job_id'] || '',
          objective : result[0]['result']['objective'] || '',
          
          // completion_date : result[0]['result']['completion_date'],
          completion_date : this.formatCompletionDate(result[0]['result']['completion_date']),
          // file_type : result[0]['result']['files'][0]['file_type'],
          // dataTable : result[0]['result']['files'][0]['dataTable']
        });
        this.files = result[0]['result']['files'];
        // this.reportService.file_id = result[0]['result']['files'] && result[0]['result']['files'][0] ? result[0]['result']['files'][0]['file_uuid'] : '';
        if(this.reportService.reportDetails['files'] && this.reportService.reportDetails['files'].length > 0){
          
          this.reportService.reportDetails['files'].map(file => {
            let myString = file['resource'];
            const ext = myString.substring(myString.lastIndexOf(".") + 1);
            file['type'] = ext;
            file['uuid'] = this.uuid;
            if(file['file_type']){
              file['file_type'] = this.reportService.formatFileType(file['file_type']);
            }else{
              file['file_type'] = "None";
            }
          })
        }
      }else if(result[0]['status'] == 4){
        this.notifier.notify("error",result[0]['message']);
        this.sidePanelService.afterLoginNavigate();
      }
      else{
        this.notifier.notify('error', 'Something went wrong.');
      }
    },error => {
      // console.error('error : ', error);
      this.notifier.notify('error', 'Something went wrong.');
    });
  }

  formatCompletionDate(_date){
    if(_date && _date.includes(" ")){
      var dateArr = _date.split(" ");
      var mon = ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateArr[1]) / 3 + 1) < 10 ? `0${"JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateArr[1]) / 3 + 1}` : "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateArr[1]) / 3 + 1;
      return `20${dateArr[2]}`+'-'+mon+'-'+dateArr[0];
    }
    return "";
  }

  projectSelected(id){
    this.createReportForm.patchValue({
      projectId: id
    })
  }
  removeListFile(index){
    this.files.splice(index, 1);
    this.createReportForm.patchValue({"file_type":''});
  }

  upload(event: Event) {
    const target = event.target as HTMLInputElement;
    this.fileObj = target.files as FileList;
    this.item = {fileObj:this.fileObj[0],file_type:this.createReportForm.value.file_type,fileName:this.getFileName(this.createReportForm.controls.file.value)};
    
    this.reportService.uploadedFiles.push(this.item);
    
    // this.createReportForm.patchValue({file_type:''});
    this.uploadFileVariable = false;
    this.removeFile();
  }

  getFileName(url){
    return url.replace(/^.*(\\|\/|\:)/, '');
  }

  removeFile(){
    this.createReportForm.controls.file.reset();
  }

  removeCurrentFile(obj){
    var index = this.reportService.uploadedFiles.indexOf(obj);
    this.reportService.uploadedFiles.splice(index,1);
  }



  checkForMandatoryFieldsAndValidation():boolean{
    const jobId = this.createReportForm.value.job_id;
    const objective = this.createReportForm.value.objective;
    let _validJobId = jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 10 || jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 12
    let _validObjective = objective && objective.length
    let _validObjectiveWordLen = objective.split(' ').length || 0;
    if(_validJobId && (_validObjective && _validObjectiveWordLen > 15)){
      return true
    }else{
      this.reportService.isLoading = false;
      if(!_validObjective || _validObjectiveWordLen < 15){
        this.reportService.notifier.notify('error','Please enter objective in details and more than 15 words.');
        return false;
      }
      if(!_validJobId){
        this.reportService.notifier.notify('error','Please enter correct 10 or 12 digit Job ID');
        return false;
      }
     
    }

  }

  onSubmit(isFormValid:boolean){
    const jobId = this.createReportForm.value.job_id;
    const objective = this.createReportForm.value.objective || "";
    const objective_word_len = objective.split(' ').length || 0;
    if (isFormValid) {
      this.focusFirstInvalidField();
      this.notifier.notify('error','Please fill all the required fields');
      return;
    }else{
      this.formatDate();
      let isVideoObjectiveCheckOn = false;
      this.reportService.uploadMultipleFileContainer.forEach(element => {
        element.forEach((file) => { 
          if (file.file_type === 'Video' || file.file_type === 'Audio') {
            isVideoObjectiveCheckOn = true;
            // console.log("file.file_type matched ===> ",file.file_type)
          }
        });
      });
      this.reportService.isLoading = true;
      this.reportService.isDisableBtn = true;
      let ischeckForIsAudioVideoTranslationCheckOn = this.checkForIsAudioVideoTranslationCheckOn();
      if(!ischeckForIsAudioVideoTranslationCheckOn){
        this.reportService.isLoading = false;
        return;
      } 
        
      let isAnalyseCheckon = this.reportService.MatSelectFileArray.some((item:any) => item.vi_index);
      if(this.isUpdate){
        if(isAnalyseCheckon){
          if(this.checkForMandatoryFieldsAndValidation()){
            this.updateReport();
          }
        }else{
          if(this.reportService.reportDetails?.objective && isVideoObjectiveCheckOn){
            if(!objective || objective_word_len < 15){
              this.reportService.isLoading = false;
              this.reportService.notifier.notify('error','Please enter objective in detail and more than 15 words.');
              return;
            }
          }
          if(objective && objective_word_len < 15 && isVideoObjectiveCheckOn){
            this.reportService.isLoading = false;
            this.reportService.notifier.notify('error','Please enter objective in detail and more than 15 words.');
            return;
          }
          if(!jobId || jobId == ''){
            this.updateReport();
          }else{
            if(jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 10 || jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 12){
              this.updateReport();
            }else{
              this.reportService.isLoading = false;
              this.reportService.notifier.notify('error','Please enter correct 10 or 12 digit Job ID');
            }
  
          }
        }
  
      }else{
        if(isAnalyseCheckon){
          if(this.checkForMandatoryFieldsAndValidation()){
            this.uploadReport();
          }
          // if(jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 10 || jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 12){
          //   this.uploadReport();
          // }else{
          //   this.reportService.isLoading = false;
          //   this.reportService.notifier.notify('error','Please enter correct 10 or 12 digit Job ID');
          // }
        }else{
          if(objective && objective_word_len < 15 && isVideoObjectiveCheckOn){
            this.reportService.isLoading = false;
            this.reportService.notifier.notify('error','Please enter objective in detail and more than 15 words.');
            return;
          }

          if(!jobId || jobId == ''){
            this.uploadReport();
          }else{
            if(jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 10 || jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 12){
              this.uploadReport();
            }else{
              this.reportService.isLoading = false;
              this.reportService.notifier.notify('error','Please enter correct 10 or 12 digit Job ID');
            }
  
          }
        }
      }
    }
  }


   onCreateAndMove(isFormValid:boolean){
    const jobId = this.createReportForm.value.job_id;
    const objective = this.createReportForm.value.objective || "";
    // console.log("****************1",isFormValid);
    if (isFormValid) {
      this.focusFirstInvalidField();
      this.notifier.notify('error','Please fill all the required fields');
      return;
    }else{
      this.formatDate();
      this.reportService.isLoading = true;
      this.reportService.isDisableBtn = true;

      if((!jobId || jobId == '') || (jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 10 || jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 12)){
        // this.reportService.createNewStudyAndMoveFiles(this.createReportForm.value);
          let selectedFiles = this.reportService.getSelectedFilesId();
          if(selectedFiles.length == 0){
            this.notifier.notify('error', 'Please select files to move');
            return;
          }
          let options: any = {};
          let input = new FormData();
          let body = this.createReportForm.value;
          input.append("description",body.description);
          input.append("title",body.title);
          input.append("type",body.type);
          input.append("projectName",body.projectName);
          input.append("projectId",body.projectId);
          input.append("tag",body.tags);
          input.append("source",body.source);
          input.append("completion_date",body.completion_date);
          input.append("job_id",body.job_id);
          if(body.bu_code && body.bu_code != ''){
            input.append("bu_code",body.bu_code);
          }
          input.append("objective",body.objective);
          options['method'] = 'POST';
          options['relativeUrl'] = '/v2/repo/uploadrepo';
          options['body'] = input ? input : {};
          options['options'] = {}; 
          options['options']['httpOptions'] = this.reportService.httpPostOptionsFile;
          options['options']['httpOptions']['reportProgress'] = true;
          options['options']['httpOptions']['observe'] = "events";
          this.apiRequest.httpCallForFileUpload(options, (response) => {
            // The callback fires for every HttpEvent (progress, response, etc.),
            // so branch explicitly instead of treating "not a response" as an error.
            if (response && response.progress !== undefined) {
              // Upload progress tick - nothing to do here for now.
              return;
            }
            if (response && response.response) {
              this.reportService.createdUUID = response.response['uuid'];
              if(response.response['status'] == 0){
                this.notifier.notify("error",response.response['message'] && response.response['message'] != '' ? response.response['message'] : "Something went wrong!");
                return;
              }
              let body = {
                  "study_id": this.reportService.createdUUID,
                  "file_id": selectedFiles,
                  "keep_original":true
                }
              this.repoService.moveFile(body).subscribe(result =>{
                if(result['status'] == 1){
                  this.reportService.isMoveAllFileOpen = false;
                  this.reportService.selectedStudyIDForMove = "";
                  this.reportService.close();
                  this.reportService.allSelectedFiles = [];
                  this.reportService.isLoading = false;
                  // this.reportService.notify.notify('success', 'Files moved successfully');
                } else if(result['status'] == 2){
                  this.reportService.isMoveAllFileOpen = false;
                  this.reportService.selectedStudyIDForMove = "";
                  this.reportService.close();
                  this.reportService.allSelectedFiles = [];
                  this.reportService.notify.notify('success', result['message']);
                  this.reportService.isLoading = false;
                }else{
                  this.notifier.notify("error","Something went wrong!");
                  this.reportService.isLoading = false;
                }
              })
              return;
            }
            // Only treat an actual HttpErrorResponse (or missing status) as a connectivity failure.
            if (response instanceof Object && 'status' in response && response.status === 0) {
              this.notifier.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
              this.reportService.isLoading = false;
            }
          });
      }else{
        this.reportService.isLoading = false;
        this.reportService.notifier.notify('error','Please enter correct 10 or 12 digit Job ID');
      }
    }
  }


  checkForIsAudioVideoTranslationCheckOn() : boolean{
    for(let i=0;i<this.reportService.MatSelectFileArray.length;i++){
      let file_type = this.reportService.MatSelectFileArray[i]['file_type'];
      let fileObj = this.reportService.MatSelectFileArray[i]['value'] || '';
      if(file_type != ''){
        if(!fileObj || fileObj == ''){
          this.notifier.notify('error','Please select file for respective file type.');
          return false;
        }
      }
      let audiotranslation_config = this.reportService.MatSelectFileArray[i]['audiotranslation_config'];
      let isAudiotranslator = this.reportService.MatSelectFileArray[i]['isAudiotranslator'];
      if(isAudiotranslator){
        let orignal_video_lang = this.reportService.MatSelectFileArray[i]['language'];
        if(!fileObj || fileObj == ''){
          this.notifier.notify('error','Please select video file for audio translation.');
          return false;
        }
        if(!orignal_video_lang || orignal_video_lang == ''){
          this.notifier.notify('error','Please select original video language.');
          return false;
        }
        if(!audiotranslation_config.fileObj || audiotranslation_config.fileObj == null){
          this.notifier.notify('error','Please select audio translation file.');
          return false;
        }
        if(!audiotranslation_config.translator_lang || audiotranslation_config.translator_lang == ''){
          this.notifier.notify('error','Please select audio translation language.');
          return false;
        }
      }
    }
    return true;
  }


  uploadFileFunc(){
    if(this.createReportForm.value.file_type != ""){
      this.uploadFileVariable = true;
      this.assignFileExtention();
    }
    else{
      this.reportService.isLoading = false;
      this.reportService.notifier.notify('error','Please select file type');
    }
  }

  assignFileExtention(){
    switch(this.createReportForm.value.file_type){
      case "Report" : this.acceptableExtentions = ".pdf,.docx,.pptx,.txt,.csv,.xlsx,.doc";
      break;
      case "Questionnaire" : this.acceptableExtentions = ".pdf,.docx,.pptx,.txt,.csv,.xlsx,.doc";
      break;
      case "Data Table - ABS" : this.acceptableExtentions = ".pptx,.csv,.xlsx,.doc,.docx";
      break;
      case "Data Table - PCT" : this.acceptableExtentions = ".pptx,.csv,.xlsx,.doc,.docx";
      break;
      case "Topline Report" : this.acceptableExtentions = ".csv,.xlsx";
      break;
      case "Image" : this.acceptableExtentions = ".png,.jpg,.jpeg";
      break;
      case "Video" : this.acceptableExtentions = ".3gp,.mp4,.MP4,.MOV,.AVI,.MKV,.3GP";
      break;
      case "Audio" : this.acceptableExtentions = ".mp3,.MP3,.m4a,.M4A,.wav,.WAV";
      break;
    }
  }

  setCreateProjectName(e){
    this.projectCreateName = e.target.value;
  }

  getFileTypeArr(){
    return this.reportService.uploadedFiles.map(ob=>{

      if(ob.file_type == 'Data Table - ABS'){
        return 'dataTable-abs';
      }
      else if(ob.file_type == 'Data Table - PCT'){
        return 'dataTable-pct';
      }else if(ob.file_type == 'Topline Report'){
        return 'kpiViewer';
      }
      else{
        return ob.file_type.toLowerCase();
      }
    });
  }

  uploadReport(){
    if(this.reportService.isStudyCreated){
      this.submitUploadAndRequest();
    }
    else{
      this.reportService.uploadNewReport(this.createReportForm.value);
    }
  }

  uploadReportV2(result){
    if(result['status'] == 1){
      this.reportService.dataSource = [];
      this.reportService.getRepos();
      this.reportService.isDisableBtn = false;
      this.reportService.createdUUID = result['uuid'];
      this.submitUploadAndRequest();
      this.reportService.isStudyCreated = true;
    }else if(result['status'] == 0){
      this.reportService.notifier.notify('error',result['message'] || 'Something went wrong.');
      this.reportService.isLoading = false;
      this.reportService.showPogress = false;
    }
  }

  submitUploadAndRequest(){
    if(this.reportService.isStudyCreated){
      if(this.reportService.isFileUploaded) {
        if(this.reportService.checkRequestFile()) this.reportService.submitRequestEmail(this.reportService.createdUUID);
        else this.reportService.close();
      }
      else if(this.reportService.isInviteFileRequested) {
        if(this.reportService.checkUploadFile()) this.uploadFile(this.reportService.createdUUID);
        else this.reportService.close();
      }
      else{
        this.shouldNotClose();
      };
    }
    else{
      if(this.shouldNotClose()){
      }
      else{
          this.reportService.close();
          this.reportService.notifier.notify('success','Study created successfully');
          this.reportService.isLoading = false;
          this.reportService.showPogress = false;
          this.progressBar.nativeElement.style.width = '0%';
      }
    }
  }

  shouldNotClose(){
    if(this.reportService.checkUploadFile() && this.reportService.checkRequestFile()){
      this.reportService.addStudySubmitProgress = 'uploadAndRequest';
      this.uploadFile(this.reportService.createdUUID);
      this.reportService.submitRequestEmail(this.reportService.createdUUID);
      return true;
    }
    else if(this.reportService.checkUploadFile() && !this.reportService.checkRequestFile()){
      this.reportService.addStudySubmitProgress = 'upload';
      this.uploadFile(this.reportService.createdUUID);
      return true;
    }
    else if(!this.reportService.checkUploadFile() && this.reportService.checkRequestFile()){
      this.reportService.addStudySubmitProgress = 'request';
      this.reportService.submitRequestEmail(this.reportService.createdUUID);
      return true;
    }
    else{
        return false;
    }
  }

  uploadFile(uuid) {
    let checkTranslationUploadValidation = this.setTranslationFileConf();
    if(!checkTranslationUploadValidation) return;

    let checkTranslationAudioUploadValidation = this.checkForTranslationAudioUploadValidation();
    if(!checkTranslationAudioUploadValidation) return;

    

    this.reportService.uploadFileContainer = [].concat.apply([],this.reportService.uploadMultipleFileContainer);
    this.reportService.uploadMultipleFileContainer = [];
    this.reportService.uploadMultipleFile(uuid);
  }

  checkForTranslationAudioUploadValidation():boolean{

    for(let i=0; i<this.reportService.uploadMultipleFileContainer.length; i++){
      let audiotranslation_config = this.reportService.MatSelectFileArray[i]['audiotranslation_config'];
      let isAudiotranslator = this.reportService.MatSelectFileArray[i]['isAudiotranslator'];
      if(isAudiotranslator){
        let orignal_video_lang = this.reportService.MatSelectFileArray[i]['language'];
        if(!orignal_video_lang || orignal_video_lang == ''){
          this.notifier.notify('error','Please select original video language.');
          return false;
        }
        if(!audiotranslation_config.fileObj || audiotranslation_config.fileObj == null){
          this.notifier.notify('error','Please select audio translation file.');
          return false;
        }
        if(!audiotranslation_config.translator_lang || audiotranslation_config.translator_lang == ''){
          this.notifier.notify('error','Please select audio translation language.');
          return false;
        }
        this.reportService.uploadMultipleFileContainer[i][0]['isAudiotranslator'] = isAudiotranslator;
        this.reportService.uploadMultipleFileContainer[i][0]['audiotranslation_config'] = audiotranslation_config;
        this.reportService.uploadMultipleFileContainer[i][0]['translator_lang'] = audiotranslation_config.translator_lang;
        this.reportService.uploadMultipleFileContainer[i][0]['language'] = orignal_video_lang;
      }
    }
    // console.log('this.RService.uploadMultipleFileContainer',this.reportService.uploadMultipleFileContainer);
    return true;

  }

  

  setTranslationFileConf() {
    let isValid = true;
    // console.log("@ Create study page SET::", this.reportService.uploadMultipleFileContainer);
    for(let i=0; i<this.reportService.uploadMultipleFileContainer.length; i++){
      let tConf: translation_config = {
        type: this.reportService.MatSelectFileArray[i]['translateConfig'].currType,
        languageColumnMap: this.reportService.MatSelectFileArray[i]['translateConfig'].customHeaders && this.reportService.MatSelectFileArray[i]['translateConfig'].customHeaders.length > 0 ? this.reportService.MatSelectFileArray[i]['translateConfig'].customHeaders : null,
      }
      // console.log("tConf::", tConf);

      let fileArr = this.reportService.uploadMultipleFileContainer[i];
      for(let j=0; j<fileArr.length; j++) {
        let file = fileArr[j];
        if(file.file_type == 'Translation'){
          if(tConf.type == 'custom'){
            if(!tConf.languageColumnMap) {
              this.reportService.notify.notify('error','Please select all the custom headers for translation file.');
              isValid = false;
              break;
            }
          } else {
            tConf.languageColumnMap = null;
          }
          this.reportService.uploadMultipleFileContainer[i][j].translation_config = tConf;
        }
      }
    }
    return isValid;
  }

  updateReport(){
    this.reportService.uploadUpdateReport(this.createReportForm.value,this.uuid);
  }

  updateUploadReportV2(result){
    if(result['status'] == 1){
      this.reportService.close();
      this.reportService.isDisableBtn = false;
      this.reportService.isLoading = false;
      this.reportService.notifier.notify('success',('Study updated successfully.'));
      this.reportService.showPogress = false;
      this.reload();
    }else{
      this.reportService.notifier.notify('error','Something went wrong.');
      this.reportService.isLoading = false;
    }
  }


  addProject(){
    let data = {};

    const orgId = JSON.parse(localStorage.getItem('access'))['org_id'];
    data['name'] = this.projectCreateName;

    data['organization_id'] = orgId;
    data['status'] = '0';
    
    if(data['name'].length > 0){
      this.projectService.createProject(data).subscribe(
        (result)=>{
          if(result['status'] === 1){
            this.notifier.notify('success', result['message']);
            this.createReportForm.patchValue({
              projectName:result['project']['name'],
              projectId:result['project']['uuid']
            });
          }else{
            this.notifier.notify('error', result['message']);
          }
        },
        (error)=>{
          if (error.status === 401) {
            this.notifier.notify('error', 'User is not authorised');
          }
          else {
            this.notifier.notify('error', 'Something went wrong');
          }
        }
      );

      this.projectCreateName = "";
    }
  }

  calenderIconClick(){
    document.getElementById("dateFormid").focus();
  }
  notifyUploadInPogress(){
    this.notifier.notify('warning','Please wait while the file is being uploaded.');
  }
  cancleCreateStudy(){
    if (this.reportService.showPogress) {
      this.notifier.notify('warning','Please wait while the file is being uploaded.');
    }else{
      this.reportService.close()
    }
  }

  cancleCreateNewStudyToMoveAllFiles(){
    this.reportService.close();
    this.reportService.isMoveAllFileOpen = true;
  }

  handleTranslationUpload(checkTranslation: boolean) {
    let previousValue = this.isTranslationFileUpload;
    this.isTranslationFileUpload = checkTranslation;
    if(previousValue !== this.isTranslationFileUpload) {
      const jobIdControl = this.createReportForm.get('job_id');
      if (this.isTranslationFileUpload) {
        jobIdControl?.setValidators([Validators.required]);
      } else {
        jobIdControl?.setValidators([]);
      }
      jobIdControl?.updateValueAndValidity();
    }
  }

  focusFirstInvalidField(): void {
    const invalidControl = document.querySelector('input.ng-invalid, mat-select.ng-invalid, textarea.ng-invalid');
    if (invalidControl) {
      (invalidControl as HTMLElement).focus();
      // Scroll the element into view
      invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
